import { CompanyAPI } from "@/api/company.api";
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { Company } from '@/models/company';

const api = new CompanyAPI()

const confirmEmail = (body: Company): AxiosObservable<Company> => api.confirmEmail(body)

export default {
  confirmEmail
}
